import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
import imageUrl from "../../../images/StudyCalculatorImg.webp";
const TITLE = "تحويل المعدل التراكمي إلى نظام الدرجات الماليزي";
const DESCRIPTION =
  "اكتشف كيفية تحويل معدلك الجامعي إلى النظام الماليزي بسهولة ودقة. اعرف تفاصيل النظام الماليزي للدرجات الجامعية.";
const KEYWORDS =
  "النظام الجامعي الماليزي, تحويل المعدل الجامعي, نظام الدرجات الماليزي, معدل البكالوريوس, معدل الماجستير, المعدل الجامعي, ماليزيا";
const OG_URL = "https://do-calculate.com/calculator/ar/gradetomalaysia";
function GpaToMalaysia() {
  const [originalValue, setOriginalValue] = useState("");
  const [convertedValue, setConvertedValue] = useState("");
  const [conversionType, setConversionType] = useState("grade");
  const [showResult, setShowResult] = useState(false);
  const [error, setError] = useState(null);
  const percentageToGpa = (percentage) => {
    if (percentage >= 93 && percentage <= 96) {
      return 4.0;
    } else if (percentage >= 90 && percentage <= 92) {
      return 3.67;
    } else if (percentage >= 87 && percentage <= 89) {
      return 3.33;
    } else if (percentage >= 83 && percentage <= 86) {
      return 3.0;
    } else if (percentage >= 80 && percentage <= 82) {
      return 2.67;
    } else if (percentage >= 77 && percentage <= 79) {
      return 2.33;
    } else if (percentage >= 73 && percentage <= 76) {
      return 2.0;
    } else if (percentage >= 70 && percentage <= 72) {
      return 1.67;
    } else if (percentage >= 67 && percentage <= 69) {
      return 1.33;
    } else if (percentage >= 65 && percentage <= 66) {
      return 1.0;
    } else if (percentage >= 0 && percentage <= 64) {
      return 0.0;
    } else {
      return "مدخلات غير صالحة";
    }
  };
  const gpaToMalaysianGrade = (gpa) => {
    if (gpa === 4.0) {
      return "A";
    } else if (gpa === 3.67) {
      return "A-";
    } else if (gpa === 3.33) {
      return "B+";
    } else if (gpa === 3.0) {
      return "B";
    } else if (gpa === 2.67) {
      return "B-";
    } else if (gpa === 2.33) {
      return "C+";
    } else if (gpa === 2.0) {
      return "C";
    } else if (gpa === 1.67) {
      return "C-";
    } else if (gpa === 1.33) {
      return "D+";
    } else if (gpa === 1.0) {
      return "D";
    } else if (gpa === 0.0) {
      return "F";
    } else {
      return "مدخلات غير صالحة";
    }
  };
  const calculateConversion = (value) => {
    if (conversionType === "grade") {
      const percentage = parseFloat(value);
      if (!isNaN(percentage) && percentage >= 0 && percentage <= 100) {
        const gpa = percentageToGpa(percentage);
        return gpaToMalaysianGrade(gpa);
      }
    } else if (conversionType === "gpa") {
      const gpa = parseFloat(value);
      if (!isNaN(gpa) && gpa >= 0 && gpa <= 4) {
        return gpaToMalaysianGrade(gpa);
      }
    }
    return "مدخلات غير صالحة";
  };
  const handleCalculateClick = () => {
    const converted = calculateConversion(originalValue);
    setConvertedValue(converted);
    setShowResult(true);
    setError(null);
  };
  const handleConversionTypeChange = (newConversionType) => {
    setConversionType(newConversionType);
    setOriginalValue("");
    setConvertedValue("");
    setShowResult(false);
    setError(null);
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
              </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  اكتشف كيفية تحويل معدلك الجامعي (مئوي أو تراكمي) إلى النظام
                  الماليزي بسهولة ودقة. اعرف تفاصيل النظام الماليزي للدرجات
                  الجامعية باستخدام هذه الأداة المفيدة.
                </p>
              </div>
              <br />
            </div>
            <hr />
             <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>
                    تحويل المعدل الجامعي إلى النظام الماليزي
                  </h2>
                </div>
                <hr />
                <div className="form-group">
                  <b>
                    <label>نوع المعدل:</label>
                  </b>
                  <div>
                    <input
                      type="radio"
                      id="gradeConversion"
                      name="conversionType"
                      value="grade"
                      checked={conversionType === "grade"}
                      onChange={() => handleConversionTypeChange("grade")}
                      className="form-check-input"
                      style={{ marginLeft: "4px" }}
                    />
                    <label
                      htmlFor="gradeConversion"
                      className="form-check-label"
                    >
                      مئوي (100)
                    </label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      id="gpaConversion"
                      name="conversionType"
                      value="gpa"
                      checked={conversionType === "gpa"}
                      onChange={() => handleConversionTypeChange("gpa")}
                      className="form-check-input"
                      style={{ marginLeft: "4px" }}
                    />
                    <label htmlFor="gpaConversion" className="form-check-label">
                      تراكمي (4.00)
                    </label>
                  </div>
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="originalValue">
                      {conversionType === "grade"
                        ? "المعدل المئوي:"
                        : "المعدل التراكمي:"}
                    </label>
                  </b>
                  <input
                    type="text"
                    value={originalValue}
                    id="originalValue"
                    onChange={(e) => setOriginalValue(e.target.value)}
                    className="form-control"
                    style={{ width: "200px", marginRight: "4px" }}
                  />
                  <button
                    className="btn btn-success mt-2"
                    onClick={handleCalculateClick}
                  >
                    احسب                  </button>
                </div>
                {error && (
                  <div className="alert alert-danger mt-2">
                    <b>
                      <u>خطأ:</u>
                    </b>{" "}
                    {error}
                  </div>
                )}
                {showResult &&  (
                  <div
                    style={{ fontSize: "15px" }}
                    className="bg-light bg-gradient text-dark mt-3 p-2"
                  >
                    <div className="p-2 bg-success bg-gradient text-white">
                      <strong>النتيجة:</strong>
                    </div>
                    <b>
                      {conversionType === "grade"
                        ? `الدرجة في النظام الماليزي: ${convertedValue}`
                        : `الدرجة الماليزية بالنسبة للمعدل التراكمي: ${convertedValue}`}
                    </b>
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col-sm-12 col-md-4">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">{TITLE}</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      نظام تصنيف الدرجات الجامعية في ماليزيا
                    </h2>
                  </u>
                  <p>
                    في ماليزيا، يتم تصنيف الدرجات الجامعية على مقياس من A إلى F،
                    حيث A هو الأفضل وF هو الأسوأ. يمكن تقسيم الدرجات على النحو
                    التالي:
                  </p>
                  <table >
                    <thead>
                      <tr className="bmi-header">
                        <th>درجة U.S. (من 100)</th>
                        <th>النسبة المئوية المكافئة</th>
                        <th>قيمة GPA</th>
                        <th>الدرجة الماليزية</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>A</td>
                        <td>93-96%</td>
                        <td>4.0</td>
                        <td>A</td>
                      </tr>
                      <tr>
                        <td>A-</td>
                        <td>90-92%</td>
                        <td>3.67</td>
                        <td>A-</td>
                      </tr>
                      <tr>
                        <td>B+</td>
                        <td>87-89%</td>
                        <td>3.33</td>
                        <td>B+</td>
                      </tr>
                      <tr>
                        <td>B</td>
                        <td>83-86%</td>
                        <td>3.00</td>
                        <td>B</td>
                      </tr>
                      <tr>
                        <td>B-</td>
                        <td>80-82%</td>
                        <td>2.67</td>
                        <td>B-</td>
                      </tr>
                      <tr>
                        <td>C+</td>
                        <td>77-79%</td>
                        <td>2.33</td>
                        <td>C+</td>
                      </tr>
                      <tr>
                        <td>C</td>
                        <td>73-76%</td>
                        <td>2.00</td>
                        <td>C</td>
                      </tr>
                      <tr>
                        <td>C-</td>
                        <td>70-72%</td>
                        <td>1.67</td>
                        <td>C-</td>
                      </tr>
                      <tr>
                        <td>D+</td>
                        <td>67-69%</td>
                        <td>1.33</td>
                        <td>D+</td>
                      </tr>
                      <tr>
                        <td>D</td>
                        <td>65-66%</td>
                        <td>1.00</td>
                        <td>D</td>
                      </tr>
                      <tr>
                        <td>F</td>
                        <td>0-64%</td>
                        <td>0.0</td>
                        <td>F</td>
                      </tr>
                    </tbody>
                  </table>
                  <p>
                    هذه المعلومات تساعد في فهم كيفية تحويل المعدلات إلى النظام
                    الماليزي ومعرفة ما يعادلها باللغة الإنجليزية والنسبة
                    المئوية.
                  </p>
                  <b className="text-primary">
                    <span>مثال: </span>
                    إذا كان لديك معدل تراكمي 3.0 على مقياس 4.0، يمكنك تحويله إلى
                    النظام الماليزي باستخدام الأداة أعلاه وستحصل على النتيجة
                    المعادلة.
                  </b>
                  <p>
                    هذه الأداة مفيدة جدًا للطلاب الدوليين الذين يرغبون في متابعة
                    دراستهم في ماليزيا أو التقديم على وظائف تطلب معدل دراسي
                    معين.
                  </p>
                  <div>
                    <p>
                      تعد ماليزيا من الدول المتقدمة علميًا، وفيها العديد من
                      الجامعات العريقة التي يقصدها الطلاب من جميع أنحاء العالم.
                    </p>
                    <p className="alert alert-info">
                      أن في ماليزيا العديد من الجامعات المصنفة عالميًا، ويمتاز
                      النظام الدراسي في الجامعات الماليزية بالصرامة العلمية
                      والجدة في المناهج. وتعد التكاليف الدراسية في ماليزيا
                      معقولة مقارنة ببقية الدول الأوروبية والولايات المتحدة
                      الأميركية.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <br />
        </div>
      </div>
    </div>
  );
}
export default GpaToMalaysia;
